import { FilterTags } from 'components/filtertags'
import { VisualizacaoMicroareasFilterModel } from 'view/visualizacaoTerritorial/model'

import { getMicroareasFilterTags } from './utils-microareasFilter'

interface MicroareasFilterTagsProps {
  filter: VisualizacaoMicroareasFilterModel | undefined
  wrap?: boolean
}

export function MicroareasFilterTags(props: MicroareasFilterTagsProps) {
  const { filter, wrap = true } = props

  const filterTags = getMicroareasFilterTags(filter)

  return <FilterTags tags={filterTags} wrap={wrap} />
}
